import Reels from "./Reels";
import ReelsSpinner from "./ReelsSpinner";
import SystemConfig from "../../system/SystemConfig";
import ISymbols from "../../engine/pixi/ISymbols";
import ISlots from "./ISlots";

class Slots implements ISlots {

    protected _gameset: any;
    protected _symbols: ISymbols;
    protected _config: SystemConfig;
    protected _reels: Reels;
    protected _spinner: ReelsSpinner;

    constructor(config: SystemConfig, columns: number, symbols: ISymbols) {

        this._gameset = config.gameset;
        this._symbols = symbols;
        this._config = config;

        this.createReels(columns);
        this.createSpinner();

    }

    createReels(columns: number) {
        this._reels = new Reels(this._gameset, columns, this._config);
    }

    createSpinner() {
        this._spinner = new ReelsSpinner(this._reels);
    }

    get reels() {
        return this._reels;
    }

    create(reelsMatrix) {
        this._reels.create();
        this.createSymbols(reelsMatrix);
        this._spinner.create();
        this._reels.print();
    }

    createSymbols(reelsMatrix) {
        this._reels.setSpinSymbols(this._symbols.createSpinSymbols(this.reels));
        this._reels.setResultSymbols(this._symbols.createResultSymbols(reelsMatrix, false));
        this._reels.setStartPositions();
        this._reels.initSymbols();
    }

    spin() {
        return this._spinner.spin();
    }

    setResult(reelsMatrix) {
        let symbols = this._symbols.createResultSymbols(reelsMatrix, true);
        this._reels.setResultSymbols(symbols);
    }

    newResult(reelMatrix) {
        this._reels.setResultSymbols(this._symbols.createResultSymbols(reelMatrix, false));
        this._reels.initSymbols();
        this._reels.print();
    }

    stop() {
        this._reels.stop();
    }

    forceStop() {
        this._reels.forceStop();
    }

    setSymbolsVisible(bool: boolean) {
        this.getSymbols().forEach(symbol => {
            symbol.visible = bool;
        });
    }

    /**
     * @return {Array<Reel>}
     */
    getReels() {
        return this._reels.getReels();
    }

    /**
     * @param {number} id
     * @return {Reel}
     */
    getReel(id) {
        return this._reels.getReel(id);
    }

    /**
     * @return {Array<ReelSpinner>}
     */
    getSpinners() {
        return this._reels.getSpinners();
    }

    /**
     * @param {number} id
     * @return {ReelSpinner}
     */
    getSpinner(id) {
        return this._reels.getSpinner(id);
    }

    getSymbols() {
        return this._reels.getSymbols();
    }

    getResultSymbolsMatrix() {
        return this._reels.getResultSymbolsMatrix();
    }

    getResultSymbols() {
        return this._reels.getResultSymbols();
    }

    getReelsConfig() {
        return this._reels.getReelsConfig();
    }
}

export default Slots;
